import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';


function ArticleGestionAutocomplete({ onChange, label, required, infosLogistique, variant, size, color }) {

    const [articles, setArticles] = useState([]);

    const [selected, setSelected] = React.useState(null);

    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);

    const [loading, setLoading] = useState(false);
    

    // Fetch des articles
    useEffect(() => {
        const fetchData = async () => {

            if (query.length >= 3) {

                let cache = null;

                let len = query.length;
                do {
                    cache = results.find(x => x.key === query.substring(0, len)); // eslint-disable-line no-loop-func
                    len--;
                }
                while (!cache && (len >= 3));

                if (cache) {
                    setArticles(cache.data);
                }
                else {
                    setLoading(true);
                    const result = await axios.get(`api/articles-gestion/suggestion?query=${query}&infosLogistique=${infosLogistique}`);
                    setResults([...results, {key:query, data: result.data}]);
                    setArticles(result.data);
                    setLoading(false);
                }
            }
        };

        fetchData();
    }, [query, infosLogistique]);


    return (
        <Autocomplete

            sx={{width: '100%'}}

            options={articles}
            getOptionLabel={(option) => option.reference + ' - ' + option.designation}

            loading={loading}

            value={selected}
            onChange={(event, newValue) => {
                setSelected(newValue);
                onChange(newValue);
            }}
            onInputChange={(event, newInputValue) => {
                setQuery(newInputValue);
            }}

            isOptionEqualToValue={(option, value) => {
                return (option.reference === value.reference);
            }}

            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    placeholder="Rechercher un article"
                    required={required}
                    variant={variant}
                    size={size}
                    color={color}
                    fullWidth
                    InputLabelProps={{
                        shrink: true
                    }}
                />
            )}
        />
    );




}

ArticleGestionAutocomplete.propTypes = {
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    infosLogistique: PropTypes.bool,

    label: PropTypes.string,

    variant: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string,
};

ArticleGestionAutocomplete.defaultProps = {
    required: false,
    infosLogistique: false,
    label: "Article",

    variant: "filled",
    size: "small",
    color: "secondary",
}


export default ArticleGestionAutocomplete;